import { buscarDadosCep } from "../../../services/api";

export const mascaraCep = (
  e: any,
  setCep: React.Dispatch<React.SetStateAction<string>>
) => {
  const digits = e.replace(/\D/g, "").slice(0, 8);
  const masked = digits.replace(/^(\d{2})(\d)/, "$1.$2").replace(/\.(\d{3})(\d)/, ".$1-$2");
  setCep(masked);
};

export const checkCEP = async (
  setEndereco: (value: React.SetStateAction<string>) => void,
  setBairro: (value: React.SetStateAction<string>) => void,
  setCidade: (value: React.SetStateAction<string>) => void,
  setEstado: (value: React.SetStateAction<string>) => void,
  cep: string
) => {
  buscarDadosCep(cep).then((res) => {
    setEndereco(res.data.logradouro);
    setBairro(res.data.bairro);
    setCidade(res.data.localidade);
    setEstado(res.data.uf);
  });
};

export const handleReset = (
  setNome: (value: React.SetStateAction<string>) => void,
  setCep: (value: React.SetStateAction<string>) => void,
  setEndereco: (value: React.SetStateAction<string>) => void,
  setBairro: (value: React.SetStateAction<string>) => void,
  setCidade: (value: React.SetStateAction<string>) => void,
  setEstado: (value: React.SetStateAction<string>) => void,
  setComplemento: (value: React.SetStateAction<string>) => void,
  setError: (value: React.SetStateAction<boolean>) => void,
  setModal: (modal: boolean) => void
) => {
  setNome("");
  setCep("");
  setEndereco("");
  setBairro("");
  setCidade("");
  setEstado("");
  setComplemento("");
  setError(false);
  setModal(false);
};
